// password forget page
import React, { useState } from "react";
import api from "../../utils/api";
import Button from "../../components/common/Button";
import { Link, useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const nav = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const res = await api.post("/auth/forgot-password", { email });
      setMessage(
        res.data.message ||
          "If the email exists, a password reset link has been sent."
      );
    } catch (err) {
      setError("Failed to send reset link. Try again.");
    }
  }

  return (
    <div className="min-h-screen flex justify-center items-center">
      <div className="bg-white w-full max-w-md p-10 rounded-3xl shadow">
        
        <h1 className="text-3xl font-bold text-center">Forgot Password</h1>
        <p className="text-gray-500 text-center">
          Enter your email to reset your password
        </p>

        {/* Error Message */}
        {error && (
          <div className="bg-red-100 text-red-600 p-3 mt-4 rounded-xl text-sm text-center">
            {error}
          </div>
        )}

        {/* Success Message */}
        {message && (
          <div className="bg-green-100 text-green-700 p-3 mt-4 rounded-xl text-sm text-center">
            {message}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4 mt-6">
          <input
            type="email"
            required
            className="border p-3 rounded-xl w-full"
            placeholder="Email address"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setError("");
              setMessage("");
            }}
          />

          <Button
            variant="primary"
            className="w-full py-3 text-lg"
            type="submit"
          >
            Send Reset Link
          </Button>
        </form>

        {/* Back to login */}
        <div className="mt-6 text-center">
          <Link to="/login" className="text-[#FF4A1F] hover:underline font-semibold">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
